<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :additionalCloseFunction="close"
        :useAdditionalSaveFunction="true"
        :additionalSaveFunction="savePersonId"
    >
        <template v-slot:editForm>
            <div v-if="isNewEntry">
                <v-row>
                    <v-col>
                        <BaseEditPageAutocomplete 
                            :context="context"
                            field="Person"
                            :label="$t('lang_AZ_GROUPS_CAPTION_PERSON')"
                            rules="required|personDoesntAlreadyExists"
                            :withFreeText="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-autocomplete-person-textfield'"
                            :additionalFunction="fillInAllFields"
                        >
                            <template v-slot:selection="{ item }">
                                <div class="ellipsis" :alvqa="alvqa + '-autocomplete-person-selection'">
                                    {{ item.gemaName }}
                                    <span v-if="$alvPlugin.printName(item)">
                                        ({{ item.firstName }} {{ item.lastName }})
                                    </span>
                                </div>
                            </template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content :alvqa="alvqa + '-autocomplete-person-dropdown-' + items.alvId">
                                    <v-list-item-title :alvqa="alvqa + '-autocomplete-person-dropdown-' + items.alvId + '-title'">
                                        {{ items.gemaName }}
                                        {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-person-dropdown-' + items.alvId + '-subtitle'">
                                        {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FirstName"
                            :label="$t('lang_GENERIC_CAPTION_FIRST_NAME')"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa + '-textfield-first-name'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="LastName"
                            :label="$t('lang_GENERIC_CAPTION_LAST_NAME')"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa + '-textfield-last-name'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Mobil"
                            :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-mobil'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Email"
                            :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-email'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Role"
                            :label="$t('lang_GENERIC_CAPTION_ROLE')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-role'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="InheritFromGroup"
                            :items="getDropdownYesNo"
                            :label="$t('lang_AZ_GROUPS_PERSONS_CAPTION_GROUP_ADDRESS_INHERITANCE')"
                            :clearable="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-dropdown-inherit-from-group'"
                        />
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <v-row>
                    <!-- <v-col>
                        {{ $t('lang_GENERIC_CAPTION_FIRST_NAME') }}: {{ selectedEntry.firstName }} 
                    </v-col>
                    <v-col>
                        {{ $t('lang_GENERIC_CAPTION_LAST_NAME') }}: {{ selectedEntry.lastName }} 
                    </v-col> -->
                    <v-col>
                        {{ $t('lang_GENERIC_AZ_CAPTION_GEMA_NAME') }}: {{ selectedEntry.gemaName }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FirstName"
                            :label="$t('lang_GENERIC_CAPTION_FIRST_NAME')"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa + '-textfield-first-name'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="LastName"
                            :label="$t('lang_GENERIC_CAPTION_LAST_NAME')"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa + '-textfield-last-name'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Mobil"
                            :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-mobil'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Email"
                            :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-email'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Role"
                            :label="$t('lang_GENERIC_CAPTION_ROLE')"
                            :withMargin="false"
                            :alvqa="alvqa + '-textfield-role'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="InheritFromGroup"
                            :items="getDropdownYesNo"
                            :label="$t('lang_AZ_GROUPS_PERSONS_CAPTION_GROUP_ADDRESS_INHERITANCE')"
                            :clearable="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-dropdown-inherit-from-group'"
                        />
                    </v-col>
                </v-row>
            </div>
        </template>
    </EditingDialog>
</template>

<script>
import { DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "PersonsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageAutocomplete,
        BaseEditPageTextarea,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            alvqa: 'az-persons-edit-panel-dialog',
            context: 'PersonsPanelEntry'
        }
    },
    computed: {
        isNewEntry() {
            let selectedItem = this.$store.getters.getSelectedPersonsPanelEntry
            let isNew = selectedItem.length === 0 
            return isNew
        },
        selectedEntry() { return this.$store.getters.getPersonsPanelEntryEditingDialogDetails },
        getDropdownYesNo() { return DropdownGenericYesNo },
    },
    methods: {
        fillInAllFields() {
            let selectedPerson = this.$store.getters.getPersonsPanelEntryDetailsPerson
            if(selectedPerson !== null && selectedPerson !== undefined) {
                this.$store.commit('setPersonsPanelEntryDetailsMobil', selectedPerson.cellphone)
                this.$store.commit('setPersonsPanelEntryDetailsEmail', selectedPerson.email)
                this.$store.commit('setPersonsPanelEntryDetailsRole', selectedPerson.role)
                this.$store.commit('setPersonsPanelEntryDetailsId', selectedPerson.id)
                this.$store.commit('setPersonsPanelEntryDetailsFirstName', selectedPerson.firstName)
                this.$store.commit('setPersonsPanelEntryDetailsLastName', selectedPerson.lastName)
                this.$store.commit('setPersonsPanelEntryDetailsKeyName', selectedPerson.gemaName)
                this.$store.commit('setPersonsPanelEntryDetailsInheritFromGroup', 'yes')
            }
        },
        close() {
            this.$store.commit('setPersonsPanelEntryDetailsPerson', null)
            this.$store.commit('setSelectedPersonsPanelEntry', [])
        },
        savePersonId(item) {
            let selectedPerson = this.$store.getters.getPersonsPanelEntryDetailsPerson
            item.id = selectedPerson.id
            
            return item
        }
    }
}
</script>